// AUTO-GENERATED — do not edit. Run `pnpm build` in packages/domain-data.
// Source: business/ishvaram/data/domain/astrology/tarot.yaml

import type { TarotReferenceCard } from "./types";

export const majorArcanaTarotCards0 = [
  {
    image_description: "A traveler at a cliff edge with a small bundle, looking upward",
    id: 0,
    name_en: "The Fool",
    name_hi: "मूर्ख",
    vedic_name: "Aarambh (The Beginning)",
    vedic_parallel: "Like Arjuna before the Gita — standing at the threshold of transformation",
    upright: {
      keywords: ["new beginnings", "innocence", "spontaneity", "free spirit"],
      meaning: "A fresh start awaits. Trust the journey even without knowing the destination.",
      advice: "Take the leap. The universe catches those who trust.",
    },
    reversed: {
      keywords: ["recklessness", "risk", "holding back", "foolishness"],
      meaning: "Hesitation or reckless action. Check if fear or ego is driving your choice.",
      advice: "Pause before jumping. Not every impulse is intuition.",
    },
    planet: "uranus",
    vedic_graha: "rahu",
    element: "air",
    arcana: "major",
    suit: null,
  },
  {
    image_description:
      "A figure with one hand raised to sky, one pointing to earth, tools before him",
    id: 1,
    name_en: "The Magician",
    name_hi: "जादूगर",
    vedic_name: "Siddha (The Accomplished)",
    vedic_parallel: "Like Vishwakarma, the divine architect — all tools of creation at hand",
    upright: {
      keywords: ["willpower", "manifestation", "skill", "resourcefulness"],
      meaning: "You have every resource you need. Channel your will and the elements align.",
      advice: "Act with focus. Your intention shapes reality.",
    },
    reversed: {
      keywords: ["manipulation", "trickery", "wasted talent", "deception"],
      meaning: "Talent without integrity leads nowhere. Are you using your gifts wisely?",
      advice: "Align your actions with dharma, not just desire.",
    },
    planet: "mercury",
    vedic_graha: "budh",
    element: "air",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A veiled woman seated between two pillars, a crescent moon at her feet",
    id: 2,
    name_en: "The High Priestess",
    name_hi: "महापुजारिन",
    vedic_name: "Yogini (The Inner Knower)",
    vedic_parallel: "Like Saraswati in meditation — the wisdom that comes from stillness",
    upright: {
      keywords: ["intuition", "mystery", "inner knowledge", "subconscious"],
      meaning: "The answer lies within. Tradition says stillness reveals what action cannot.",
      advice: "Trust your inner voice. Not everything needs to be spoken.",
    },
    reversed: {
      keywords: ["secrets", "withdrawal", "silence", "disconnection"],
      meaning: "You may be ignoring your intuition or hiding from a truth you already know.",
      advice: "Sit quietly. The clarity you seek is already present.",
    },
    planet: "moon",
    vedic_graha: "chandra",
    element: "water",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A crowned woman seated in a lush garden, surrounded by grain and flowers",
    id: 3,
    name_en: "The Empress",
    name_hi: "साम्राज्ञी",
    vedic_name: "Devi (The Mother)",
    vedic_parallel: "Like Annapurna — the goddess of abundance who nourishes all creation",
    upright: {
      keywords: ["abundance", "fertility", "nature", "nurturing", "beauty"],
      meaning: "A season of growth and abundance. Creation flows naturally from you.",
      advice: "Nurture what you have planted. The harvest is approaching.",
    },
    reversed: {
      keywords: ["dependence", "stagnation", "creative block", "neglect"],
      meaning: "You may be neglecting self-care or blocking your own creative flow.",
      advice: "Reconnect with nature and your body. Abundance starts with self-nourishment.",
    },
    planet: "venus",
    vedic_graha: "shukra",
    element: "earth",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A king on a stone throne, holding a scepter, mountains behind him",
    id: 4,
    name_en: "The Emperor",
    name_hi: "सम्राट",
    vedic_name: "Chakravartin (The Sovereign)",
    vedic_parallel: "Like Raja Rama — righteous authority that protects through dharma",
    upright: {
      keywords: ["authority", "structure", "stability", "discipline", "leadership"],
      meaning: "Structure and discipline serve you now. Lead with fairness and firmness.",
      advice: "Build your foundation. Order creates the space for greatness.",
    },
    reversed: {
      keywords: ["tyranny", "rigidity", "domination", "lack of discipline"],
      meaning: "Authority without compassion becomes oppression. Flexibility is also strength.",
      advice: "Examine where control has replaced care.",
    },
    planet: "mars",
    vedic_graha: "mangal",
    element: "fire",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A robed spiritual teacher between two pillars, two students kneeling",
    id: 5,
    name_en: "The Hierophant",
    name_hi: "धर्मगुरु",
    vedic_name: "Guru (The Teacher)",
    vedic_parallel: "Like Guru Brihaspati — the one who transmits sacred knowledge through lineage",
    upright: {
      keywords: ["tradition", "spiritual guidance", "conformity", "education", "wisdom"],
      meaning: "Seek guidance from tradition and those who have walked the path before you.",
      advice: "A teacher or teaching is ready to appear. Be open to learning.",
    },
    reversed: {
      keywords: ["rebellion", "unorthodox", "restriction", "challenging status quo"],
      meaning: "Blind adherence to tradition may be limiting you. Question, but with respect.",
      advice: "Find your own truth, but do not discard ancient wisdom carelessly.",
    },
    planet: "jupiter",
    vedic_graha: "guru",
    element: "earth",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "Two figures beneath a radiant angel, standing in a garden of choice",
    id: 6,
    name_en: "The Lovers",
    name_hi: "प्रेमी",
    vedic_name: "Mithuna (The Union)",
    vedic_parallel: "Like Shiva and Shakti — the sacred union of opposites that creates wholeness",
    upright: {
      keywords: ["love", "harmony", "choices", "alignment", "partnership"],
      meaning:
        "A meaningful choice or union is before you. Follow what aligns your heart and mind.",
      advice: "Choose from love, not fear. True union begins with inner harmony.",
    },
    reversed: {
      keywords: ["disharmony", "imbalance", "misalignment", "temptation"],
      meaning: "A relationship or choice feels off. Examine where values conflict.",
      advice: "Realign before committing. Harmony cannot be forced.",
    },
    planet: "venus",
    vedic_graha: "shukra",
    element: "air",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A warrior in a chariot drawn by two sphinxes, a canopy of stars above",
    id: 7,
    name_en: "The Chariot",
    name_hi: "रथ",
    vedic_name: "Vijaya Ratha (The Victory Chariot)",
    vedic_parallel: "Like Krishna steering Arjuna's chariot — willpower guided by divine wisdom",
    upright: {
      keywords: ["victory", "determination", "willpower", "triumph", "control"],
      meaning: "Victory through focused will. The chariot moves when purpose is clear.",
      advice: "Harness your opposing forces. Directed energy conquers all obstacles.",
    },
    reversed: {
      keywords: ["aggression", "lack of direction", "defeat", "scattered energy"],
      meaning: "Force without direction leads to defeat. Are you charging ahead blindly?",
      advice: "Pause to steer before you accelerate.",
    },
    planet: "moon",
    vedic_graha: "chandra",
    element: "water",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A woman gently holding open the jaws of a lion, an infinity symbol above",
    id: 8,
    name_en: "Strength",
    name_hi: "शक्ति",
    vedic_name: "Shakti (Inner Power)",
    vedic_parallel: "Like Durga taming the lion — courage through compassion, not brute force",
    upright: {
      keywords: ["courage", "inner strength", "patience", "compassion", "resilience"],
      meaning: "True strength is gentle. Patient endurance overcomes what force cannot.",
      advice: "Meet challenges with composure. Your calm is your greatest weapon.",
    },
    reversed: {
      keywords: ["self-doubt", "weakness", "insecurity", "raw emotion"],
      meaning: "Inner doubt is louder than outer obstacles. Where has your confidence gone?",
      advice: "Reconnect with your core. Strength returns when self-trust is restored.",
    },
    planet: "sun",
    vedic_graha: "surya",
    element: "fire",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A robed figure on a mountain peak, holding a lantern, looking down",
    id: 9,
    name_en: "The Hermit",
    name_hi: "तपस्वी",
    vedic_name: "Tapasvi (The Ascetic)",
    vedic_parallel: "Like Vyasa in the cave — withdrawing from the world to see the truth within",
    upright: {
      keywords: ["solitude", "introspection", "guidance", "inner light", "wisdom"],
      meaning: "A time for withdrawal and reflection. The answers are found in silence.",
      advice: "Step away from noise. Your inner lamp illuminates the path.",
    },
    reversed: {
      keywords: ["isolation", "loneliness", "withdrawal", "lost direction"],
      meaning:
        "Solitude has become isolation. You may be hiding from life instead of seeking truth.",
      advice: "Seek connection. Even hermits eventually share their wisdom.",
    },
    planet: "mercury",
    vedic_graha: "budh",
    element: "earth",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A great wheel with figures rising and falling, a sphinx at the top",
    id: 10,
    name_en: "Wheel of Fortune",
    name_hi: "भाग्यचक्र",
    vedic_name: "Kalachakra (The Wheel of Time)",
    vedic_parallel: "Like the cycle of yugas — what rises must fall, what falls must rise again",
    upright: {
      keywords: ["destiny", "cycles", "turning point", "luck", "karma"],
      meaning: "The wheel turns. A karmic shift brings new opportunities and circumstances.",
      advice: "Accept the change. Karma delivers what your actions have earned.",
    },
    reversed: {
      keywords: ["bad luck", "resistance to change", "broken cycle", "setback"],
      meaning: "Resisting the natural cycle only prolongs suffering. Let the wheel turn.",
      advice: "Release your grip. What seems like loss may be the universe rearranging.",
    },
    planet: "jupiter",
    vedic_graha: "guru",
    element: "fire",
    arcana: "major",
    suit: null,
  },
] as const satisfies readonly TarotReferenceCard[];
